import { render, staticRenderFns } from "./PropertyCustomer.vue?vue&type=template&id=4db8a4ec&scoped=true&lang=pug&"
import script from "./PropertyCustomer.vue?vue&type=script&lang=js&"
export * from "./PropertyCustomer.vue?vue&type=script&lang=js&"
import style0 from "./PropertyCustomer.vue?vue&type=style&index=0&id=4db8a4ec&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db8a4ec",
  null
  
)

export default component.exports